import * as mutation from "./mutations-types";
import defaultState from "./state";
import _cloneDeep from "lodash/cloneDeep";

export default {
  [mutation.RESET](state) {
    const s = defaultState;
    Object.keys(s).forEach(key => {
      state[key] = _cloneDeep(s[key]);
    });
  },

  [mutation.UPDATE_AUCTION](state, auction) {
    state.filter.specialConditions = [
      ...state.filter.specialConditions,
      auction
    ];
  },

  // TODO: Fix update all filter
  [mutation.UPDATE_FILTER](state, filter) {
    // state.filter = _cloneDeep(filter);
    state.filter = filter;
  },

  [mutation.UPDATE_ADTYPE](state, adType) {
    state.filter.adType = adType;
  },

  [mutation.UPDATE_ADTYPES](state, adTypes) {
    state.filter.adTypes = [...adTypes];
  },

  [mutation.UPDATE_PROPERTY_TYPES](state, propertyTypes) {
    state.filter.propertyTypes = [...state.filter.propertyTypes, propertyTypes];
  },

  [mutation.RESET_PROPERTY_TYPES](state) {
    state.filter.propertyTypes = [];
  },

  [mutation.UPDATE_ROOMS](state, rooms) {
    state.filter.rooms = rooms;
  },

  [mutation.UPDATE_PRICES_FROM](state, pf) {
    state.filter.price.from = pf;
  },

  [mutation.UPDATE_PRICES_TO](state, pt) {
    state.filter.price.to = pt;
  },

  [mutation.UPDATE_ZONES](state, zones) {
    state.filter.zones = [...state.filter.zones, zones];
  },

  [mutation.UPDATE_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  }
};
